import { Injectable } from '@angular/core';
import { Router, ROUTES } from '@angular/router';
import { ApplicationService } from './application.service';
import { CacheService } from './cache.service';
import { Location } from '@angular/common';
import { STEPS } from '../constants/steps.constants';
import { APP_ROUTES } from '../constants/routes.constants';
import { CACHE_VARIABLES } from '../constants/cache-variables.constants';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  route: string = '';
  pageName: string = '';
  constructor(
    private router: Router,
    private _cacheService: CacheService,
    location: Location
  ) {
    if (location.path() != '') {
      this.route = location.path();
      var routeString = this.route.slice(1);
      this.pageName = this.getStepName(routeString);
    }
  }

  navigateToStep(stepToNavigateTo: string, state?: any): void {
    let current_page = this.getRouteFromCurrentStep(stepToNavigateTo);
    this._cacheService.setItem(CACHE_VARIABLES.RoutePath, current_page);
    this._cacheService.setItem(CACHE_VARIABLES.ROUTE_STATE, state);
    this.router.navigate([`/${current_page}`], { state: state });
  }
  getRouteFromCurrentStep(currentStep: string): string {
    let routeName: string;

    switch (currentStep) {
      case STEPS.APP_SELECTION:
        routeName = APP_ROUTES.APP_SELECTION;
        break;
      default:
        routeName = currentStep;
        break;
    }
    return routeName.toLowerCase();
  }
  getStepName(currentStep: string): string {
    let stepName: string;

    switch (currentStep) {
      case APP_ROUTES.APP_SELECTION:
        stepName = 'app-selection';
        break;
      default:
        stepName = currentStep;
        break;
    }
    return stepName;
  }

  

  logout(){    
    this._cacheService.cleanLocalStorage();
    this._cacheService.cleanSessionStorage();
    this.navigateToStep('login');
  }
}
